import { createSelector } from 'reselect';
import { fromJS, List, Map } from 'immutable';

import { isAuthenticated } from 'redux/selectors/user';
import { getActiveOrderId, isUploading } from 'redux/selectors/app';
import { getCurrentBookSpreads } from 'redux/selectors/books';
import { getPhotos, getPicked, getUploads } from 'redux/selectors/photos';
import { getDesignSpreads } from 'redux/selectors/design';

export const getStats = state => state.getIn(['stats', getActiveOrderId(state)], Map());

const _calculateProgress = (spreads, designSpreads, photos, picked) => {
  const progress = {};

  spreads.forEach(spread => {
    const designSpread = designSpreads.get(spread.get('id'));
    const moments = spread.get('moments', List());
    const total = moments.count();
    let touched = 0;

    if (designSpread) {
      designSpread.get('moments').forEach(moment => {
        const currentSpreadMoment = spread.get('moments').find(m => m.get('id') == moment.get('id'));

        const isText = currentSpreadMoment.get('type') === 'text';
        const userSet = picked.get(moment.get('id'), null);
        const hasPhoto = userSet
          ? photos.find(photo => {
              return photo.get('simpleId') === userSet.get('simpleId');
            })
          : false;

        const specialText = moment.getIn(['options', 'special_text']);

        if (((hasPhoto || isText) && userSet !== null) || specialText) {
          touched++;
        }
      });
    }

    progress[spread.get('id')] = {
      total,
      touched,
      seen: touched > 0,
      partial: touched > 0 && touched < total,
      done: total === touched,
    };
  });

  // Spread has been seen
  //

  return fromJS(progress);
};

export const calculateProgress = createSelector(
  [getCurrentBookSpreads, getDesignSpreads, getPhotos, getPicked],
  (spreads, designSpreads, photos, picked) => {
    return _calculateProgress(spreads, designSpreads, photos, picked);
  }
);

export const readyCheck = createSelector(
  [
    getCurrentBookSpreads,
    getDesignSpreads,
    getPhotos,
    getActiveOrderId,
    getPicked,
    getUploads,
    isUploading,
    isAuthenticated,
  ],
  (spreads, designSpreads, photos, orderId, picked, uploads, uploading, authenticated) => {
    // Every spread filled in
    const progress = _calculateProgress(spreads, designSpreads, photos, picked);
    const done = !progress.isEmpty() && progress.every(spread => spread.get('done')) && orderId !== null;

    // Seems done, but doesn't have any photos
    const noPhotos = false;

    const uploadQueue = [];
    picked.forEach(pick => {
      if (pick.get('simpleId') && !uploads.get(pick.get('simpleId'))) {
        uploadQueue.push(pick.get('simpleId'));
      }
    });

    return {
      all: done && authenticated && !uploading,
      uploading: uploading || uploadQueue.length > 0,
      noPhotos,
      done,
      authenticated,
    };
  }
);

export const readyCheckDone = createSelector([readyCheck], check => check.done);



// WEBPACK FOOTER //
// ./app/redux/selectors/stats.js